import {
  AccessTime,
  AccountCircle,
  Email,
  Phone,
  Person,
  InfoOutlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useContractorUserDetailContext } from "contexts/ContractorUserDetailContext";
import moment from "moment";
import Status from "components/Shared/Status";

const formatDate = (dateString) => moment(dateString).format("MMMM Do, YYYY");

const ContractorUserBasicDetails = () => {
  const { contractorUserDetail, loadingDetail } =
    useContractorUserDetailContext();

  return !loadingDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <InformationTile
                  icon={() => <AccountCircle color="primary" />}
                  title="Name"
                  subtitle={contractorUserDetail?.name}
                />
              </Grid>

              <Grid item xs={3}>
                <InformationTile
                  icon={() => <AccountCircle color="primary" />}
                  title="Contractor ID"
                  subtitle={contractorUserDetail?.contractorUserID}
                />
              </Grid>

              <Grid item xs={3}>
                <InformationTile
                  title="Email"
                  icon={() => <Email color="primary" />}
                  subtitle={contractorUserDetail?.email}
                />
              </Grid>

              <Grid item xs={3}>
                <InformationTile
                  title="Phone"
                  icon={() => <Phone color="primary" />}
                  subtitle={contractorUserDetail?.phone}
                />
              </Grid>

              {contractorUserDetail?.alternatePhone && (
                <Grid item xs={3}>
                  <InformationTile
                    title="Alternate Phone"
                    icon={() => <Phone color="primary" />}
                    subtitle={contractorUserDetail?.alternatePhone}
                  />
                </Grid>
              )}
              {contractorUserDetail?.userRef && (
                <Grid item xs={3}>
                  <InformationTile
                    title="Connected User"
                    icon={() => <Person color="primary" />}
                    subtitle={contractorUserDetail?.userRef?.name}
                  />
                </Grid>
              )}

              <Grid item xs={3}>
                <InformationTile
                  title="Created At"
                  icon={() => <AccessTime color="primary" />}
                  subtitle={formatDate(contractorUserDetail?.createdAt)}
                />
              </Grid>

              <Grid item xs={3}>
                <InformationTile
                  title="Updated At"
                  icon={() => <AccessTime color="primary" />}
                  subtitle={formatDate(contractorUserDetail?.updatedAt)}
                />
              </Grid>

              <Grid item xs={3}>
                <InformationTile
                  icon={() => <InfoOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={contractorUserDetail?.isActive} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default ContractorUserBasicDetails;
